export const PageInicio = {
    title: 'Inicio',
    url: '/inicial'
}